import { Route, Routes, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { usePageInfo } from '../../config/queries'
import { useGlobalNewsItem, useGlobalNewsItems } from '../../config/queries'
import { uploadGlobalNewsFile } from '../../api/globalNews'
import GlobalNewsItem from './GlobalNewsItem'
import NewsForm from '../shared/News/NewsForm'
import NotFound from '../Error/NotFound'
import NewsLayout from './NewsLayout'

const useCanManage = () => {
  const {
    data: { user },
  } = usePageInfo()
  return !!user?.superAdmin
}

const NewsLandingIndex = () => {
  const { t } = useTranslation()
  const { data: items, isPending } = useGlobalNewsItems()
  const canManage = useCanManage()

  const mostRecent =
    items?.find((item) => item.published) ??
    (canManage ? items?.[0] : undefined)

  return (
    <NewsLayout>
      {isPending ? null : mostRecent ? (
        <GlobalNewsItem
          key={mostRecent.id}
          item={mostRecent}
          canManage={canManage}
          newsPath='/news'
          hideBack
        />
      ) : (
        <p className='text-muted-foreground'>{t('news.no-posts')}</p>
      )}
    </NewsLayout>
  )
}

const NewsLandingView = () => {
  const { id } = useParams()
  const newsItemId = id ? parseInt(id) : undefined
  const { data: newsItem, isPending } = useGlobalNewsItem(newsItemId)
  const canManage = useCanManage()

  return (
    <NewsLayout>
      {isPending ? null : newsItem ? (
        <GlobalNewsItem
          key={newsItem.id}
          item={newsItem}
          canManage={canManage}
          newsPath='/news'
          hideBack
        />
      ) : (
        <NotFound nested={true} />
      )}
    </NewsLayout>
  )
}

const NewsLandingForm = () => {
  const { id } = useParams()
  const newsItemId = id ? parseInt(id) : undefined
  const { data: existingItem, isPending } = useGlobalNewsItem(newsItemId)
  const canManage = useCanManage()

  return (
    <NewsLayout>
      <NewsForm
        entityType='global_news_item'
        existingItem={existingItem}
        isPending={isPending}
        listQueryKey={['globalNewsItems']}
        uploadFile={async (file) => (await uploadGlobalNewsFile(file)).url}
        showTargetSelector={false}
        showTags={true}
        canManage={canManage}
      />
    </NewsLayout>
  )
}

const News = () => {
  return (
    <Routes>
      <Route path='/' element={<NewsLandingIndex />} />
      <Route path='/new' element={<NewsLandingForm />} />
      <Route path='/:id' element={<NewsLandingView />} />
      <Route path='/:id/edit' element={<NewsLandingForm />} />
    </Routes>
  )
}

export default News
